import { appStateService, store } from "App";
import { ClientOrderStatus } from "enums/order/ClientOrderStatus";
import { IChartAPI, IProductSalesEntry } from "../interfaces";
import { actions } from "redux/reducers/dashboard/dashboardGraphDataReducer";
import { chartIds } from "components/page/home/dashboard/graphs/chart.ids";
import { DashboardGraphDataSelectors } from "redux/selectors/dashboard/graph/dashboardGraphDataSelectors";

const _singletonUnsubscribes = {
	product: null,
	order: null
};

const _internalData = {
	productList: null,
	orderList: null
};

// export class ProductSalesChartAPI implements IChartAPI<IProductSalesEntry> {
export class ProductSalesChartAPI {
	private _companyId: null | string = null;

	constructor(companyId: string) {
		this._companyId = companyId;
	}

	async getChartData(): Promise<void> {
		const self = this;
		const graphAPIService = appStateService.company.reports.graphAPI.get();
		const currentTimestamp = new Date();
		const currentMonth = currentTimestamp.getMonth();
		const currentYear = currentTimestamp.getFullYear();
		// store the items
		const productIdNameMap: { [key: string]: string } = {};
		const _productSales: { name: string; count: number }[] = [];
		const _productCounts: { [key: string]: number } = {};

		_singletonUnsubscribes.product = await appStateService.company.product
			.get()
			.getAllLive((productsItems) => {
				productsItems.forEach((product) => {
					productIdNameMap[product.id] = product.name;
				});

				graphAPIService.storeGraphDataById(
					chartIds.productSales,
					productsItems.map(
						(item) =>
							({
								id: item.id,
								productName: item.name,
								date: new Date(), // TODO: Review the use
								salesCount: 0
							} as IProductSalesEntry)
					)
				);

				// TODO: Stores the data for using
				// appStateService.company.
				// _internalData.productList = productsItems;

				// update the data
				// onUpdated(_productSales);
			});
		// if (!_singletonUnsubscribes.product || productsResult.length === 0) {
		// 	return null;
		// }

		_singletonUnsubscribes.order = await appStateService.company.order
			.get()
			.getAllLive((orderItems) => {
				// store the items

				if (!orderItems || orderItems.length === 0) {
					return null;
				}

				const filteredOrders = orderItems.filter((order) => {
					const orderDate = order.timestamp.toDate();
					return (
						orderDate.getMonth() === currentMonth &&
						orderDate.getFullYear() === currentYear &&
						order.status !== ClientOrderStatus.cancelled &&
						order.status !== ClientOrderStatus.rejected &&
						order.status !== ClientOrderStatus.error
					);
				});

				if (filteredOrders.length === 0) {
					return null;
				}

				// let _productCounts: { [key: string]: number } = {};
				filteredOrders.forEach((order) => {
					order.items.forEach((item) => {
						if (productIdNameMap[item.itemId]) {
							_productCounts[item.itemId] =
								(_productCounts[item.itemId] || 0) +
								item.quantity;
						}
					});
				});

				Object.keys(_productCounts).forEach((productId) => {
					_productSales.push({
						name: productIdNameMap[productId],
						count: _productCounts[productId]
					});
				});

				// graphAPIService.storeGraphDataById(chartIds.productSales, {});

				const finalSales = _productSales.sort(
					(a, b) => a.count - b.count
				);

				debugger;
			});

		// return _productSales.map((product) => ({
		// 	id: product.name,
		// 	productName: product.name,
		// 	date: currentTimestamp,
		// 	salesCount: product.count
		// }));

		// return {
		// 	productNames: _productSales.map((p) => ({ name: p.name })),
		// 	productCounts: _productSales.map((p) => p.count)
		// };
	}

	async getSalesByProduct(
		onUpdated: (data: IProductSalesEntry[]) => void
	): Promise<void> {}

	// /**
	//  * Stores the graph data by its ID.
	//  *
	//  * @param chartId
	//  * @param data
	//  */
	// private storeGraphDataById<ChartEntryType extends IProductSalesEntry>(
	// 	chartId: string,
	// 	data: ChartEntryType[]
	// ): void {
	// 	store.dispatch(actions.setDataById({ graphId: chartId, data }));
	// }
}
